import { BASE_CONTEXT_V2_ADMIN } from '../api-context';

export const SURVEYS = {
  CREATE:   `${BASE_CONTEXT_V2_ADMIN}survey/create`,
  LIST:     `${BASE_CONTEXT_V2_ADMIN}survey/list`,
  DETAIL:   (survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey/${survey_id}`,
  ACTIVATE: (survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey/${survey_id}/activate`,
  DELETE:   (survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey/${survey_id}`,
  ATTEMPT: {
    START:   (survey_id: number)  => `${BASE_CONTEXT_V2_ADMIN}survey/${survey_id}/attempt/start`,
    ANSWER:  (attempt_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey/attempt/${attempt_id}/answer`,
    CURRENT: (attempt_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey/attempt/${attempt_id}`,
  },
};
